import { AppRoute } from '@agentselly/immodossier-shared';
import { evaluationWidgets } from '~/config/widgets/evaluationWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_$CONTACTID_DOSSIER_$DOSSIERID_EVALUATION,
  evaluationWidgets,
);
